module.exports = __webpack_public_path__ + "assets/img/33_719.db87c92b.jpg";